// import Vue from 'vue'
import Router from 'vue-router'

// Vue.use(Router)
// 需要缓存的页面 keepAlive设为true, meta.key和页面 Name 一致
export default new Router({
	mode: 'hash',
	routes: [{
		path: '/',
		name: '首页',
		component: resolve => require(['../pages/homepage/index.vue'], resolve),
		meta: {title: 'DFS', keepAlive: true, key: 'Index'}
	}, {
		path: '/User',
		name: '订单',
		component: resolve => require(['../pages/hotel/user.vue'], resolve),
		meta: {title: 'DFS'}
	},{
		path: '/Success/:type?',
		name: '预定成功',
		component: resolve => require(['../pages/homepage/success.vue'], resolve),
		meta: {title: 'Enquiry'}
	}, {
		path: '/List/:type?/:rightType?',
		name: '权益列表',
		component: resolve => require(['../pages/homepage/pagelist.vue'], resolve),
		meta: {title: 'DFS', keepAlive: true, key: 'PageList'}
	}, {
		path: '/Search/:rightType?',
		name: '权益搜索',
		component: resolve => require(['../pages/homepage/search.vue'], resolve),
		meta: {title: 'Search',keepAlive: true, key: 'Search'}
	}, {
		path: '/Detail/:id?/:type?',
		name: '权益详情',
		component: resolve => require(['../pages/homepage/detail.vue'], resolve),
		meta: {title: 'Detail'}
	}, {
		path: '/Book/:type?',
		name: '在线预订',
		component: resolve => require(['../pages/homepage/book.vue'], resolve),
		meta: {title: 'Enquiry', keepAlive: true, key: 'GeneralBook'}
	}, {
		path: '/Payment',
		name: '确认提交',
		component: resolve => require(['../pages/homepage/payment.vue'], resolve),
		meta: {title: 'Enquiry'}
	}, {
		path: '/Adyen',
		name: '支付',
		component: resolve => require(['../pages/homepage/adyen.vue'], resolve),
		meta: {title: 'Enquiry'}
	}, , {
		path: '/Login/:phone?',
		name: '登录',
		component: resolve => require(['../pages/login.vue'], resolve),
		meta: {title: 'Login'}
	}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js